var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.303,
    height: 18.448,
    viewBox: "0 0 23.303 18.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-art-gallery",
    "data-name": "Icon map-art-gallery",
    d: "M471.651,3986.223a4.2,4.2,0,0,1-4.293-4.3c0-1.747-1.066-2.459-3.68-2.459a3.386,3.386,0,0,1-2.76-1.23,4.874,4.874,0,0,1-.92-3.074,7.158,7.158,0,0,1,2.606-4.613,10.661,10.661,0,0,1,7.206-2.767c4.028,0,7.225.724,9.5,2.153a8.471,8.471,0,0,1,3.986,7.687,7.666,7.666,0,0,1-2.836,5.918C478.377,3985.292,475.329,3986.223,471.651,3986.223Zm0-6.148a1.844,1.844,0,1,0,1.839,1.845A1.829,1.829,0,0,0,471.651,3980.074Zm-7.665-6.149a1.535,1.535,0,1,0,1.084.451A1.525,1.525,0,0,0,463.986,3973.925Zm14.1-1.231a1.536,1.536,0,1,0,1.085.451A1.537,1.537,0,0,0,478.09,3972.694Zm-4.906-2.459a1.538,1.538,0,0,0-1.533,1.538,1.532,1.532,0,1,0,1.533-1.538Zm-4.905,0a1.537,1.537,0,1,0,1.533,1.538A1.525,1.525,0,0,0,468.279,3970.235Z",
    transform: "translate(-460 -3967.775)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterests);
export default __webpack_public_path__ + "static/media/interests.809890a3e4fb0938f61bb8a6c34a6940.svg";
export { ForwardRef as ReactComponent };